import { render, staticRenderFns } from "./StudyOnline2.vue?vue&type=template&id=6efe31d8&scoped=true"
import script from "./StudyOnline2.vue?vue&type=script&lang=js"
export * from "./StudyOnline2.vue?vue&type=script&lang=js"
import style0 from "./StudyOnline2.vue?vue&type=style&index=0&id=6efe31d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe31d8",
  null
  
)

export default component.exports